<template>
  <div id="cc-google-sso" class="text-center connect-google-account" >
    <h3 class="title">Let's get started</h3>
    <h5 class="sub-title">Select the email address you use to manage your Google Ads</h5>
    <p v-if="get_sso_error" class="text-danger" v-text="formatted_sso_error" />
    <google-connection-btn class="google-btn" @success="handleSuccess" @failure="handleFailure"/>
    <p class="explainer">This connection is for reporting purposes only.</p>

    <error-modal :show-modal="modal.show" :text="modal.text" @closed="modal.show = false" />
    <reconnect-modal :show-modal="showReconnectModal"  @closed="showReconnectModal = false" />
  </div>
</template>

<script>
import { GoogleLoginMixin } from "@/mixins/GoogleLoginHandler";

export default {
  name: "ConnectGoogleAccount",
  mixins: [ GoogleLoginMixin ],
  mounted() {
    this.$store.commit("RESET_GOOGLE");
  }
}
</script>

<style lang="scss" scoped>
.connect-google-account {
  max-width: 516px;
  margin: 0 auto;
}
.google-btn {
  margin: 36px auto 36px;
}
.explainer {
  font-family: "Sofia Pro Light";
  margin: 0;
  padding: 0;
  letter-spacing: 0.2px;
}
</style>